export const BUDGET_SEARCH_SESSION_KEY = "wallet-watch:budget-search";
export const EXPENSES_SEARCH_SESSION_KEY = "wallet-watch:expenses-search";
export const ANALYSIS_CHARTS_CATEGORY_SESSION_KEY = "wallet-watch:analysis-charts-category";
export const ANALYSIS_CHARTS_PAYMENT_METHOD_SESSION_KEY = "wallet-watch:analysis-charts-payment-method";
export const ANALYSIS_CHARTS_SERVICE_SESSION_KEY = "wallet-watch:analysis-charts-service";
export const ANALYSIS_CHARTS_SUPPLIER_SESSION_KEY = "wallet-watch:analysis-charts-supplier";
const ANALYSIS_CHARTS_PENDING_METRIC_SESSION_KEY = "wallet-watch:analysis-charts-pending-metric";

function setSessionSearchValue(key, value) {
  try {
    window.sessionStorage.setItem(key, String(value ?? ""));
  } catch {
    // ignore session storage failures
  }
}

export function setExpensesSearchQuery(value) {
  setSessionSearchValue(EXPENSES_SEARCH_SESSION_KEY, value);
}

export function setBudgetSearchQuery(value) {
  setSessionSearchValue(BUDGET_SEARCH_SESSION_KEY, value);
}

export function setAnalysisChartCategory(value) {
  setSessionSearchValue(ANALYSIS_CHARTS_CATEGORY_SESSION_KEY, value);
  setSessionSearchValue(ANALYSIS_CHARTS_PENDING_METRIC_SESSION_KEY, "category-expenses");
}

export function setAnalysisChartExpenses() {
  setSessionSearchValue(ANALYSIS_CHARTS_PENDING_METRIC_SESSION_KEY, "all-expenses");
}

export function setAnalysisChartService(value) {
  setSessionSearchValue(ANALYSIS_CHARTS_SERVICE_SESSION_KEY, value);
  setSessionSearchValue(ANALYSIS_CHARTS_PENDING_METRIC_SESSION_KEY, "service-expenses");
}

export function setAnalysisChartPaymentMethod(value) {
  setSessionSearchValue(ANALYSIS_CHARTS_PAYMENT_METHOD_SESSION_KEY, value);
  setSessionSearchValue(ANALYSIS_CHARTS_PENDING_METRIC_SESSION_KEY, "payment-method-expenses");
}

export function setAnalysisChartSupplier(value) {
  setSessionSearchValue(ANALYSIS_CHARTS_SUPPLIER_SESSION_KEY, value);
  setSessionSearchValue(ANALYSIS_CHARTS_PENDING_METRIC_SESSION_KEY, "supplier-expenses");
}

export function getAnalysisChartsPendingMetric() {
  try {
    return window.sessionStorage.getItem(ANALYSIS_CHARTS_PENDING_METRIC_SESSION_KEY) ?? "";
  } catch {
    return "";
  }
}

export function clearAnalysisChartsPendingMetric() {
  try {
    window.sessionStorage.removeItem(ANALYSIS_CHARTS_PENDING_METRIC_SESSION_KEY);
  } catch {
    // ignore session storage failures
  }
}
